module.exports = __webpack_public_path__ + "img/15.729b9c14.png";